import { render, staticRenderFns } from "./ProfileFieldCategoryDialog.vue?vue&type=template&id=44b5beab"
import script from "./ProfileFieldCategoryDialog.vue?vue&type=script&lang=js"
export * from "./ProfileFieldCategoryDialog.vue?vue&type=script&lang=js"
import style0 from "./ProfileFieldCategoryDialog.vue?vue&type=style&index=0&id=44b5beab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports